<template>
    <span class="sponsorship" v-if="sponsor">
        <span v-if="inFooter"
              class="sponsorship__footer-wrapper">
            <app-sponsorship-content class="sponsorship__content"
                                     :show-logo="showLogo" />
        </span>
        <span v-else
              class="sponsorship__content-wrapper">
            <app-sponsorship-content class="sponsorship__content"
                                     :show-logo="showLogo" />
            <br>
        </span>
    </span>
</template>

<script>

import AppSponsorshipContent from './app-sponsorship-content'

export default {

    props: {
        showLogo: {
            type: Boolean,
            default: true,
        },
        inFooter: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        /**
         * @returns {Object} The sponsor object.
         */
        sponsor() {
            return this.$scheme.sponsor
        },
    },

    components: {
        AppSponsorshipContent,
    },
}

</script>


<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_app-sponsorship.scss

.sponsorship {
    padding: 0;
    margin: 0;

    @include element('content-wrapper') {

        & a {
            display: block;
        }

        & img {
            height: 3.5rem;
        }
    }

    @include element('footer-wrapper') {
        display: none;

        @include bp-min-wide {
            display: inline-block;

            & img {
                height: 2.2rem;
            }
        }
    }

}

</style>
